<div id="barBody">
  <app-kpi [cDataModel]="data" [cOptions]="chartOptions"></app-kpi>
</div>